const products_path = 'products/products/'

const list = ({ opt = {} }) => axios.get(products_path, opt)
const create = ({ form, opt = {} }) => axios.post(products_path, form, opt)
const edit = ({ pk, form, opt = {} }) =>
  axios.put(`${products_path}${pk}/`, form, opt)
const show = ({ pk, opt = {} }) => axios.get(`${products_path}${pk}/`, opt)
const remove = ({ pk }) => axios.delete(`${products_path}${pk}/`)
const excel = ({ pk, params, opt = {} }) =>
  axios.get(`inventory/getInventoryExcel/${pk}/${params}`, {
    ...opt,
    responseType: 'blob'
  })
const pdf = ({ pk, params, opt = {} }) =>
  axios.get(`inventory/getInventoryPdf/${pk}/${params}`, {
    ...opt,
    responseType: 'blob'
  })

export default {
  list,
  create,
  edit,
  show,
  remove,
  pdf,
  excel
}
